import { GLOBAL_OBJ } from '@sentry/utils';

/**
 * Get the future flags from the Remix browser context
 *
 * @returns The future flags
 */
function getFutureFlagsBrowser() {
  const window = GLOBAL_OBJ ;

  if (!window.__remixContext) {
    return;
  }

  return window.__remixContext.future;
}

/**
 * Get the future flags from the Remix server build
 *
 * @param build The Remix server build
 *
 * @returns The future flags
 */
function getFutureFlagsServer(build) {
  return build.future;
}

export { getFutureFlagsBrowser, getFutureFlagsServer };
//# sourceMappingURL=futureFlags.js.map
